import { Text } from "@chakra-ui/react"
import React from "react"

export const PDPHeaderFallback: React.FC = () => (
  <Text variant="acuminLight" mt="0">
    Oops, something went wrong.
    <br />
    If the error persists, please contact member happiness for further
    assistance.
  </Text>
)
